import SearchableSelect from "Components/Common/SearchableSelect";
import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import {
  adminDownloadPayslipZip,
  adminGetComboMember,
} from "helpers/backend_helpers";
import moment from "moment";
import { useEffect, useState } from "react";
import Flatpickr from "react-flatpickr";
import { toast } from "react-toastify";
import {
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Spinner,
} from "reactstrap";

const DownloadPayslipModalZip = ({ show, onCloseClick }: any) => {
  const [filterMonth, setFilterMonth] = useState<any>(null);
  const [filterStartMonth, setFilterStartMonth] = useState<any>(null);
  const [filterEndMonth, setFilterEndMonth] = useState<any>(null);
  const [filterMember, setFilterMember] = useState<any>(null);
  const [flatpickrKey, setFlatpickrKey] = useState(0);
  const [downloadType, setDownloadType] = useState<string>("all");
  const [isLoading, setIsLoading] = useState<boolean>(false);

  const searchMembers = async (name: string) => {
    const query = { name };
    return await adminGetComboMember(query);
  };

  const formatMemberOption = (member: any) => {
    return {
      label: `${member.name} - ${member.noId}`,
      value: member._id,
    };
  };

  const handleDownloadTypeChange = (type: string) => {
    setDownloadType(type);
    if (type === "all") {
      setFilterStartMonth(null);
      setFilterEndMonth(null);
      setFilterMember(null);
      setFlatpickrKey((prev) => prev + 1);
    }
  };

  const downloadData = async () => {
    if (downloadType === "specific") {
      const hasMonthFilter =
        filterStartMonth !== null || filterEndMonth !== null;
      const hasMemberFilter = filterMember !== null;

      if (!hasMonthFilter && !hasMemberFilter) {
        toast.error("Pilih minimal satu filter untuk download data tertentu!");
        return;
      }

      if (
        filterStartMonth &&
        filterEndMonth &&
        moment(filterStartMonth)
          .startOf("month")
          .isAfter(moment(filterEndMonth).endOf("month"))
      ) {
        toast.error("Bulan awal tidak boleh lebih besar dari bulan akhir!");
        return;
      }
    }
    setIsLoading(true);
    try {
      let query: any = {};

      if (downloadType === "specific") {
        if (filterStartMonth) {
          query.startPayDate = moment(filterStartMonth)
            .startOf("month")
            .format("YYYY-MM-DD");
        }
        if (filterEndMonth) {
          query.endPayDate = moment(filterEndMonth)
            .endOf("month")
            .format("YYYY-MM-DD");
        }
        if (filterMember) {
          query.memberId = filterMember.value;
        }
      }

      const response: any = await adminDownloadPayslipZip(query);

      const url = window.URL.createObjectURL(new Blob([response]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", `Data Slip Gaji.zip`);
      document.body.appendChild(link);
      link.click();
      link.remove();
      toast.success("Unduh data slip gaji berhasil");
      onCloseClick();
    } catch (error) {
      toast.error("Gagal mengunduh data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (!show) {
      setFilterStartMonth(null);
      setFilterEndMonth(null);
      setFilterMember(null);
      setDownloadType("all");
      setFlatpickrKey((prev) => prev + 1);
      setIsLoading(false);
    }
  }, [show]);

  return (
    <Modal
      fade={true}
      isOpen={show}
      toggle={onCloseClick}
      centered={true}
      size="md"
    >
      <ModalHeader
        className="bg-gradient-to-r from-blue-50 to-indigo-50 border-0 p-4"
        toggle={onCloseClick}
      >
        <div className="d-flex align-items-center">
          {/* <div className="bg-primary bg-opacity-10 rounded-circle p-2 me-3">
            <i className="ri-download-2-line text-primary fs-5"></i>
          </div> */}
          <div>
            <h5 className="mb-0 text-dark fw-semibold">
              Unduh Data Slip Gaji (Zip)
            </h5>
          </div>
        </div>
      </ModalHeader>

      <ModalBody className="p-4">
        <div className="mb-4">
          <Label className="form-label text-dark fw-semibold mb-3">
            Pilih Tipe Unduhan
          </Label>
          <div className="d-flex gap-3">
            <div
              className={`flex-fill border rounded-3 p-3 cursor-pointer transition-all ${
                downloadType === "all"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25 hover:border-primary"
              }`}
              onClick={() => handleDownloadTypeChange("all")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadAll"
                  checked={downloadType === "all"}
                  onChange={() => handleDownloadTypeChange("all")}
                />
                <Label
                  className="form-check-label d-flex align-items-center cursor-pointer"
                  htmlFor="downloadAll"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-folder-download-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Semua Data</div>
                    <small className="text-muted">
                      Download semua slip gaji
                    </small>
                  </div>
                </Label>
              </div>
            </div>

            <div
              className={`flex-fill border rounded-3 p-3 cursor-pointer transition-all ${
                downloadType === "specific"
                  ? "border-primary bg-primary bg-opacity-10"
                  : "border-secondary border-opacity-25 hover:border-primary"
              }`}
              onClick={() => handleDownloadTypeChange("specific")}
              style={{ cursor: "pointer" }}
            >
              <div className="form-check mb-0">
                <Input
                  className="form-check-input"
                  type="radio"
                  name="downloadType"
                  id="downloadSpecific"
                  checked={downloadType === "specific"}
                  onChange={() => handleDownloadTypeChange("specific")}
                />
                <Label
                  className="form-check-label d-flex align-items-center cursor-pointer"
                  htmlFor="downloadSpecific"
                  style={{ cursor: "pointer" }}
                >
                  <i className="ri-filter-3-line me-2 fs-5"></i>
                  <div>
                    <div className="fw-semibold">Data Tertentu</div>
                    <small className="text-muted">Filter data slip gaji</small>
                  </div>
                </Label>
              </div>
            </div>
          </div>
        </div>

        {downloadType === "specific" && (
          <div className="animate-fade-in">
            <div className="border-top pt-4 mt-2">
              <Label className="form-label text-dark fw-semibold mb-3">
                <i className="ri-filter-line me-2"></i>
                Filter Data
              </Label>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-calendar-line me-1"></i>
                  Rentang Bulan &amp; Tahun
                </Label>
                <div className="d-flex gap-3">
                  <div className="flex-fill">
                    <Flatpickr
                      key={`start-${flatpickrKey}`}
                      className="form-control shadow-sm"
                      options={{
                        plugins: [
                          monthSelectPlugin({
                            shorthand: true,
                            dateFormat: "m-Y",
                            altFormat: "F Y",
                          }),
                        ],
                      }}
                      onChange={(selectedDates) => {
                        setFilterStartMonth(selectedDates[0] || null);
                      }}
                      value={filterStartMonth}
                      placeholder="Bulan awal"
                    />
                  </div>
                  <div className="flex-fill">
                    <Flatpickr
                      key={`end-${flatpickrKey}`}
                      className="form-control shadow-sm"
                      options={{
                        plugins: [
                          monthSelectPlugin({
                            shorthand: true,
                            dateFormat: "m-Y",
                            altFormat: "F Y",
                          }),
                        ],
                      }}
                      onChange={(selectedDates) => {
                        setFilterEndMonth(selectedDates[0] || null);
                      }}
                      value={filterEndMonth}
                      placeholder="Bulan akhir"
                    />
                  </div>
                </div>
              </div>

              <div className="mb-3">
                <Label className="form-label text-muted small mb-2">
                  <i className="ri-user-search-line me-1"></i>
                  Karyawan
                </Label>
                <SearchableSelect
                  value={filterMember}
                  onChange={setFilterMember}
                  onSearch={searchMembers}
                  formatOptionLabel={formatMemberOption}
                  placeholder="Cari karyawan..."
                  minSearchLength={2}
                  itemsPerPage={5}
                  isClearable
                />
              </div>
            </div>
          </div>
        )}
      </ModalBody>
      <ModalFooter className="bg-light border-0 p-4">
        <button
          type="button"
          className="btn btn-light border shadow-sm px-4 btn-sm"
          onClick={onCloseClick}
          disabled={isLoading}
        >
          <i className="ri-close-line me-1"></i>
          Batal
        </button>
        <button
          type="button"
          className="btn btn-primary shadow-sm px-4 btn-sm"
          onClick={downloadData}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <Spinner size="sm" className="me-2" />
              Mengunduh...
            </>
          ) : (
            <>
              <i className="ri-download-2-line me-1"></i>
              Unduh Data
            </>
          )}
        </button>
      </ModalFooter>

      <style>{`
        .animate-fade-in {
          animation: fadeIn 0.3s ease-in;
        }

        @keyframes fadeIn {
          from {
            opacity: 0;
            transform: translateY(-10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .hover\\:border-primary:hover {
          border-color: #6366f1 !important;
        }

        .transition-all {
          transition: all 0.2s ease-in-out;
        }

        .cursor-pointer {
          cursor: pointer;
        }

        .bg-opacity-10 {
          --bs-bg-opacity: 0.1;
        }

        .border-opacity-25 {
          --bs-border-opacity: 0.25;
        }
      `}</style>
    </Modal>
  );
};

export default DownloadPayslipModalZip;
